interface ChannelMapping {
  [key: string]: string;
}

export const CHANNEL_DISPLAY_NAMES: ChannelMapping = {
  'y5k8d6qffty1igzqdg4ni5drfe': 'General',
  'uqim3mxgdtnddpufuurjdwe66a': 'BOLO',
  'zibtai4p1fympnue7jpwdxzoqo': 'Commercial Burglaries',
  '6b6p7ghinigmjeq7z3gysdjaar': 'Hotline',
  'edfwwefwxpy9t857mf5zzwo5jy': 'Off-Topic',
  'ujiqzj7boirwmdko95d7mgfwaw': 'SATG',
  '9qy8rr8x4bff8gn6e6wdpx7f6r': 'Stolen Vehicles'
};

export const MODEL_DESCRIPTIONS: { [key: string]: string } = {
  'buffalo_l': 'large scale triplet loss (ResNet50@WebFace600K)',
  'buffalo_s': 'compact triplet loss (MBF@WebFace600K)',
  'antelopev2': 'margin based loss (Resnet100@Glint360K)',
  'adaface': 'adaptive margin loss (ResNet101@WebFace12M)',
  'magface': 'magnitude aware softmax loss (Resnet100@MS1MV2)'
};
